// extracted by mini-css-extract-plugin
module.exports = {"landing":"_206OZRK4L5KWfjD4gr9cuQ==","page":"_3wiWy6OhH6GkTA-Y-YZyRw==","modal":"QM+XgCDFTcVO3ja9xV06cw=="};